import { Collapse, Divider, Spin } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
} from "../../components/styled/common";
import { CDNFileItems } from "./constants";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useCDNFileContext } from "../../context/CDNFileContext/CDNFileContext";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

const EditCDNFile = () => {
	const { id } = useParams<{ id: string }>();
	const { updateCDNFile, operationStatus, clearCDNFileData, getCDNFileDetails } = useCDNFileContext();

	useEffect(() => {
		clearCDNFileData();

		if (id) {
			getCDNFileDetails(id);
		}

		return () => {
			clearCDNFileData();
		};
	}, [id]);

	return (
		<ActionContainer>
			<Spin spinning={operationStatus.type === "loading" && operationStatus.operation === "fetch"}>
				<ActionItemsContainer>
					<h3>CDN Dosyasını Güncelle</h3>
					<Divider />
					<Collapse
						items={CDNFileItems}
						expandIconPosition="end"
						bordered={false}
						ghost
						expandIcon={CollapseExpandIcon}
						defaultActiveKey={["1", "2"]}
					/>
					<SubmitButtonOverlay>
						<MainButtonComponent onClick={updateCDNFile} type="default" loading={operationStatus.type === "loading" && operationStatus.operation === "update"}>
							Güncelle
						</MainButtonComponent>
					</SubmitButtonOverlay>
				</ActionItemsContainer>
			</Spin>
		</ActionContainer>
	);
};

export default EditCDNFile;
